// CRTR Studios — mock content (frontend only)

export const nav = [
  { label: "WORK", href: "/#work" },
  { label: "WHAT WE DO", href: "/#whatwedo" },
  { label: "ABOUT", href: "/#about" },
];

export const hero = {
  lines: ["CREATOR.", "RELEVANCE.", "PERFORMANCE."],
  kicker: "CONNECTING PEOPLE, BRANDS & PERFORMANCE.",
  sub: "Good people. Great performance. Real relevance.",
  body:
    "CRTR Studios ist ein Creator Ecosystem für Menschen, Marken und Ideen mit echtem Potenzial. Creator Hub, Brand Network, Media, Content, Commerce und Business Development — näher zusammen, besser verbunden.",
  image: "/images/stock-2.jpg",
};

export const intro = {
  kicker: "INTRO",
  title: ["RELEVANCE IS A", "PEOPLE BUSINESS."],
  body: [
    "Am Ende sind es nie die Plattformen, Tools oder Algorithmen, die etwas relevant machen. Es sind Menschen.",
    "Menschen mit Haltung, Geschmack, Community, Vertrauen, Erfahrung und manchmal einfach der richtigen Idee zur richtigen Zeit.",
    "CRTR Studios bringt diese Menschen zusammen. Nicht möglichst viele. Die richtigen.",
  ],
  image: "/images/stock-5.jpg",
};

export const whoWeAre = {
  kicker: "WHO WE ARE",
  title: ["NOT A NETWORK.", "MORE LIKE GRAVITY."],
  body:
    "CRTR Studios verbindet Brands, Creator, Live-Shopping und NextGen Konsumenten und generiert messbaren Umsatz und Image-Transfer im zur Zeit weltweit größten Wachstumsmarkt. CRTR Studios ist dabei kultureller Meltingpot und Plattform für Live-Shopping Channels über Vertical-Serienformate bis hin zu Creator-Driven-Products, Creator-Seeding-Campaigns und mehr. Let’s get in touch.",
  pairs: [
    ["Creator", "Brands"],
    ["Brands", "Culture"],
    ["Stories", "Media"],
    ["Content", "Commerce"],
    ["Reichweite", "Business"],
  ],
  outro: "Nicht als Prozessdiagramm. Eher wie ein gutes Umfeld.",
};

export const operatingSystem = {
  kicker: "OUR OPERATING SYSTEM",
  items: [
    { num: "01", icon: "Target", title: "STRATEGY", desc: "Culture-first Strategie. Gebaut mit Intelligenz und Instinkt." },
    { num: "02", icon: "Globe", title: "NETWORK", desc: "Die richtigen Creator. Die richtigen Communities. Echte Verbindungen." },
    { num: "03", icon: "PlayCircle", title: "CONTENT", desc: "Ideen, die treffen. Content, der reist und Menschen bewegt." },
    { num: "04", icon: "Sparkles", title: "EXPERIENCES", desc: "Physisch, digital, IRL. Erlebnisse, die Kultur in Echtzeit schaffen." },
    { num: "05", icon: "ShoppingBag", title: "COMMERCE", desc: "Vom Produkt zum Drop. Wir bauen, was Menschen wirklich wollen." },
    { num: "06", icon: "Radio", title: "AMPLIFICATION", desc: "Distribution, die performt. Reichweite mit echtem Impact." },
  ],
};

export const edge = {
  kicker: "OUR EDGE",
  title: ["ACCESS IS EASY.", "TRUST IS RARE."],
  body: [
    "Kontakte kann man kaufen. Vertrauen nicht.",
    "CRTR Studios ist über Jahre aus echten Beziehungen gewachsen — zwischen Creator Culture, Brands, Medien, Produktion, Strategie und Business.",
    "Das macht uns nicht lauter. Aber oft schneller, näher und relevanter.",
  ],
};

export const capabilities = {
  kicker: "WHAT WE DO",
  title: ["ONE STUDIO.", "MANY MOVES."],
  items: [
    { tag: "CREATOR HUB", head: "PEOPLE, NOT INVENTORY.", body: "Creator sind keine Buchungsoptionen. Sie sind Personal Brands, Communities, Medien, Unternehmer und kulturelle Multiplikatoren." },
    { tag: "CREATOR BUSINESS", head: "FAME IS NICE. EQUITY IS NICER.", body: "Wir entwickeln mit Creatorn neue Geschäftsmodelle rund um Produkte, Collections, Formate, IP, Commerce und eigene Brands." },
    { tag: "FOR BRANDS", head: "DON’T JUST SHOW UP. BELONG.", body: "Wir denken Creator Partnerships nicht als Media Placement, sondern als kulturellen Fit. Mensch. Marke. Timing. Story. Community." },
    { tag: "CONTENT", head: "CONTENT IS EASY. ATTENTION ISN’T.", body: "Social-native Content, Vertical Series und Formate, die für Feeds, Communities und Sehgewohnheiten von heute gebaut sind." },
    { tag: "MEDIA & PRESS", head: "DON’T JUST GET SEEN. GET TALKED ABOUT.", body: "Wir verbinden Social, Creator Culture und Content mit Presse- und Media-Leverage. So wird aus einem Moment mehr als Content." },
    { tag: "LIVE SHOPPING", head: "ENTERTAINMENT WITH A CHECKOUT BUTTON.", body: "Creator, Story, Produkt, Community und Conversion gehören in dasselbe Format. Nicht nacheinander. Gleichzeitig." },
    { tag: "EXPERIENCES", head: "IRL IS STILL PREMIUM.", body: "Experiences, Creator Gatherings und Brand Platforms, die wie Orte wirken, an denen man ohnehin sein möchte." },
    { tag: "OWNED PLATFORMS", head: "BORROWED ATTENTION ENDS. OWNED RELEVANCE STAYS.", body: "Eigene Formate, Plattformen und Experiences mit eigener Identität, Community und Energie." },
  ],
};

export const work = {
  kicker: "SELECTED WORK",
  intro: "THE IDEA BEFORE THE CASE.",
  cases: [
    { id: "CASE 01", title: "Creator Brand: Schlafi by fionntime", image: "/schlafi/hotpants.jpg", link: "/work/schlafi" },
    { id: "CASE 02", title: "Fictional Series: Das Internat — Fictional Content mit Creator", video: "/das-internat-trailer.mp4", image: "/das-internat-poster.jpg", link: "/work/das-internat" },
    { id: "CASE 03", title: "Social Commerce: Candy Peak mit Mario Novembre", image: "/candypeak/hero.jpg", link: "/work/candy-peak" },
  ],
};

export const universe = {
  kicker: "CRTR UNIVERSE",
  title: ["WE CONNECT THE DOTS.", "WE MOVE CULTURE.", "WE BUILD WHAT’S NEXT."],
  nodes: [
    { label: "CREATOR", image: "/creator-mario.jpg" },
    { label: "BRANDS", image: "/images/stock-6.jpg" },
    { label: "MEDIA", image: "/images/stock-4.jpg" },
    { label: "COMMUNITIES", image: "/images/stock-1.jpg" },
    { label: "COMMERCE", image: "/creator-finn-pyjama.png" },
    { label: "CULTURE", image: "/images/stock-3.jpg" },
  ],
};

export const creators = {
  kicker: "CRTR CREATOR",
  title: ["THE FACES OF", "THE MOVEMENT."],
  body:
    "All About Artists ist Teil von CRTR Studios. Eine Auswahl der Creator, mit denen wir Kultur bewegen \u2014 Personal Brands, Communities und echte Reichweite.",
  list: [
    { name: "MARIO NOVEMBRE", image: "/images/creator-1.jpg", href: "https://www.instagram.com/marionovembre/", stats: [{ p: "instagram", v: "1,9M", url: "https://www.instagram.com/marionovembre/" }, { p: "tiktok", v: "5,3M", url: "https://www.tiktok.com/@marionovembre" }, { p: "youtube", v: "517K", url: "https://www.youtube.com/@MarioNovembre/featured" }] },
    { name: "FINN SCHOEWING", image: "/images/creator-2.jpg", href: "https://www.instagram.com/fionntime/", stats: [{ p: "instagram", v: "440K", url: "https://www.instagram.com/fionntime/" }, { p: "tiktok", v: "2,9M", url: "https://www.tiktok.com/@fionntime?lang=de-DE" }, { p: "youtube", v: "792K", url: "https://www.youtube.com/@fionntime/videos" }, { p: "twitch", v: "119K", url: "https://www.twitch.tv/fionntime?lang=de" }] },
    { name: "LEON PELZ", image: "/images/creator-8.jpg", href: "https://www.instagram.com/leonpelz/", stats: [{ p: "instagram", v: "99K", url: "https://www.instagram.com/leonpelz/" }, { p: "tiktok", v: "313K", url: "https://www.tiktok.com/@leonpelz?lang=de-DE" }, { p: "youtube", v: "14,5K", url: "https://www.youtube.com/@leonpelzz" }] },
    { name: "RAED", image: "/images/creator-5.jpg", href: "https://www.instagram.com/raed_offiziell/", stats: [{ p: "instagram", v: "244K", url: "https://www.instagram.com/raed_offiziell/" }, { p: "tiktok", v: "1,5M", url: "https://www.tiktok.com/@raed_offiziell?lang=de-DE" }] },
    { name: "DIE LOCKENK\u00d6PFE", ai: true, image: "/images/creator-6.jpg", href: "https://www.instagram.com/dielockenkoepfe/", stats: [{ p: "instagram", v: "25,1K", url: "https://www.instagram.com/dielockenkoepfe/" }, { p: "tiktok", v: "38K", url: "https://www.tiktok.com/@die.lockenkoepfe" }, { p: "youtube", v: "16,4K", url: "https://www.youtube.com/@die.lockenk%C3%B6pfe" }] },
    { name: "NAYEF", image: "/images/creator-4.jpg", href: "https://www.instagram.com/nayef.nayeff/", stats: [{ p: "instagram", v: "160K", url: "https://www.instagram.com/nayef.nayeff/" }, { p: "tiktok", v: "902K", url: "https://www.tiktok.com/@nayef.nayef?lang=de-DE" }, { p: "youtube", v: "707K", url: "https://www.youtube.com/@Nayef.Nayeff" }] },
    { name: "CARLOS", image: "/images/creator-3.jpg", href: "https://www.instagram.com/achhcarlos/", stats: [{ p: "instagram", v: "11,9K", url: "https://www.instagram.com/achhcarlos/" }, { p: "tiktok", v: "9,6K", url: "https://www.tiktok.com/@achhcarlos.clips?lang=de-DE" }, { p: "youtube", v: "21K", url: "https://www.youtube.com/@AchhCarlos-Darts/videos" }, { p: "twitch", v: "20K", url: "https://www.twitch.tv/achhcarlos" }] },
    { name: "ABDUL", image: "/images/creator-7.jpg", href: "https://www.instagram.com/abdul.abduull/", stats: [{ p: "instagram", v: "34,6K", url: "https://www.instagram.com/abdul.abduull/" }, { p: "tiktok", v: "240K", url: "https://www.tiktok.com/@abdul.abduul?lang=de-DE" }] },
    { name: "ANTONIA PARENSEN", image: "/images/creator-antonia.jpg", href: "https://www.instagram.com/tonisfoodcravings/", stats: [{ p: "instagram", v: "4,2K", url: "https://www.instagram.com/tonisfoodcravings/" }, { p: "tiktok", v: "0,7K", url: "https://www.tiktok.com/@tonithefox" }, { p: "youtube", v: "0,1K", url: "https://www.youtube.com/@tonifox2464" }] },
    { name: "NOAH FITZON", image: "/images/creator-noah.jpg", href: "https://www.instagram.com/noahfitzon/", stats: [{ p: "instagram", v: "2,5K", url: "https://www.instagram.com/noahfitzon/" }, { p: "tiktok", v: "2,1K", url: "https://www.tiktok.com/@noahfitzelon" }] },
    { name: "DANY LEHEL", image: "/images/creator-9.jpg", href: "https://www.instagram.com/dany_dancybg/", stats: [{ p: "instagram", v: "4,1K", url: "https://www.instagram.com/dany_dancybg/" }] },
    { name: "TOM LEHEL", image: "/images/creator-10.jpg", href: "https://www.instagram.com/leheltom/", stats: [{ p: "instagram", v: "3,7K", url: "https://www.instagram.com/leheltom/" }, { p: "tiktok", v: "12K", url: "https://www.tiktok.com/@tomlehel?lang=de-DE" }, { p: "youtube", v: "1,5K", url: "https://www.youtube.com/channel/UCHWotPYWwWYhNuCqR-xYRug" }] },
  ],
};

export const brands = {
  kicker: "SELECTED BRANDS",
  title: "GOOD COMPANY.",
  note: "Keine Logo-Sammlung. Nur ein kleiner Hinweis darauf, wo wir schon mitreden durften.",
  list: ["RED BULL", "PRO7SAT.1", "McDONALD’S", "SONY", "SPAR", "MAN", "DEPOT", "DEVELEY", "ISS"],
};

export const manifesto = {
  lines: ["NO ASSHOLES.", "NO BULLSHIT.", "NO BORING WORK."],
  principles: [
    { icon: "Users", text: "PEOPLE BEFORE PROFILES." },
    { icon: "Crosshair", text: "RELEVANCE BEFORE REACH." },
    { icon: "Zap", text: "PERFORMANCE WITHOUT SELLING OUT." },
  ],
  note: "Unsere No-Asshole-Policy ist keine lustige Zeile fürs Deck. Sie ist Teil unseres Systems. Simple as that.",
};

export const howWeThink = {
  kicker: "HOW WE THINK",
  title: ["PEOPLE FIRST.", "RELEVANCE MATTERS.", "PERFORMANCE FOLLOWS."],
  body:
    "Nicht als Claim. Als Logik. Die richtigen Menschen schaffen Vertrauen. Vertrauen schafft Relevanz. Relevanz schafft Wirkung. Und Wirkung darf sich am Ende gerne in Brand Impact, Community, Earned Media, Commerce oder Umsatz zeigen.",
};

export const finalCta = {
  small: "LET’S",
  big: "MAKE IT REAL.",
  cta: "BRING US YOUR DREAM",
  note: "You can buy attention. Trust takes longer. Deshalb bauen wir lieber an Beziehungen, Ideen und Plattformen, die bleiben.",
};

export const footer = {
  nav,
  tagline: "GOOD PEOPLE. GREAT PERFORMANCE. REAL RELEVANCE.",
  socials: [
    { icon: "Instagram", url: "https://www.instagram.com/crtr_group" },
    { icon: "Music2", url: "https://vm.tiktok.com/ZGd9UVkJf/" },
    { icon: "Youtube", url: "https://www.youtube.com/@CRTRGroup" },
  ],
  copyright: "© CRTR STUDIO. ALL RIGHTS RESERVED.",
};
